export const SLICE_NAME = 'shopify';

export const MANAGE_PLANS_PATH = '/manage_plans';
